import { InvertThemeContext, useThemeStore } from '@stoplight/mosaic';
import { useContext } from 'react';
import shallow from 'zustand/shallow';

import { darkTheme } from './dark';
import { lightTheme } from './light';

export const useCodeTheme = () => {
  const { inverted } = useContext(InvertThemeContext);
  const [isLightBg, isLightInvertedBg] = useThemeStore(
    s => [s.colorValues.light, s.invertedColorValues.light],
    shallow,
  );

  if (inverted) {
    return isLightInvertedBg ? lightTheme : darkTheme;
  }

  return isLightBg ? lightTheme : darkTheme;
};
